import { useState } from "react";
import { Check, Link2, Linkedin, Twitter } from "lucide-react";
import { SITE_URL } from "../lib/seo";

const btn =
  "inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-neutral-300 text-xs font-semibold text-neutral-700 hover:border-indigo-800 hover:text-indigo-800 transition-colors";

export default function ShareButtons({ kind, slug, title }) {
  const [copied, setCopied] = useState(false);
  const url = `${SITE_URL}/api/share/${kind}/${slug}`;
  const enc = encodeURIComponent(url);
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="eyebrow mr-1">Share</span>
      <a className={btn} href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc}`} target="_blank" rel="noopener noreferrer" data-testid="share-linkedin">
        <Linkedin size={13} /> LinkedIn
      </a>
      <a className={btn} href={`https://twitter.com/intent/tweet?url=${enc}&text=${encodeURIComponent(title)}`} target="_blank" rel="noopener noreferrer" data-testid="share-x">
        <Twitter size={13} /> X
      </a>
      <button type="button" className={btn} onClick={copy} data-testid="share-copy-link">
        {copied ? <Check size={13} /> : <Link2 size={13} />} {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
